const headerLanguages = document.querySelector('[data-header-languages]')

if (headerLanguages) {
	const currentLanguage = headerLanguages.querySelector('.header-languages__item.header-languages__item--current')
	const otherLanguages = headerLanguages.querySelectorAll('.header-languages__item')

	document.addEventListener('click', (e) => {
		if (e.target.closest('.header-languages')) {
			if (!currentLanguage.classList.contains('active')) {
				currentLanguage.classList.add('active')
				headerLanguages.style.overflow = 'visible'
			} else {
				currentLanguage.classList.remove('active')
				headerLanguages.style.overflow = 'hidden'
			}
		}
	})
}
